import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit'
import {
  getSigners,
  demoteSigners as demoteSignersService,
  promoteSigners as promoteSignersService
} from '@src/services/signers.service'
import { RootState } from '@src/store'
import { IApiUser, IUser } from '@src/models'

type ISignersState = {
  signers: IUser[]
  allSigners: IUser[]
  status: string
  error: string | null
  meta: any
}

type Ipagination = {
  page: number
  items: number
  terms: string
}

const query = {
  page: 1,
  items: 10,
  terms: ""
} 

export const fetchSigners = createAsyncThunk(
  'signers/fetchSigners',
  async (q: Ipagination) => {
    const signers = await getSigners(q)
    return signers
  }
)

export const promoteSigners = createAsyncThunk(
  'signers/promoteSigners',
  async ({ tokens }: { tokens: string[] }, thunksApi) => {
    await promoteSignersService(tokens)
    thunksApi.dispatch(fetchSigners(query))
  }
)

export const demoteSigners = createAsyncThunk(
  'signers/demoteSigners',
  async ({ tokens }: { tokens: string[] }, thunksApi) => {
    await demoteSignersService(tokens)
    thunksApi.dispatch(fetchSigners(query))
  }
)

const signersSlice = createSlice({
  name: 'signers',
  initialState: {
    signers: [],
    allSigners: [],
    status: 'idle',
    error: null,
    meta: {} as any
  } as ISignersState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSigners.pending, (state) => {
      state.status = 'loading'
    })
    builder.addCase(fetchSigners.fulfilled, (state, action) => {
      state.status = 'successed'
      const newSigners = action.payload.data.map((signer: IApiUser) => {
        return { ...signer, key: signer.token }
      })
      state.signers = newSigners
      const currentSigners = JSON.parse(JSON.stringify(state?.allSigners))
      state.allSigners = currentSigners.concat(newSigners)
      state.meta = action.payload.meta
    })
    builder.addCase(fetchSigners.rejected, (state) => {
      state.status = 'failed'
    })
  }
})

export const selectSignersStatus = createSelector(
  (state: RootState) => state.signers,
  ({ status }) => status
)

export const selectAllSigners = createSelector(
  (state: RootState) => state.signers,
  ({ allSigners }) => allSigners
)

export const selectSigners = createSelector(
  (state: RootState) => state.signers,
  ({ signers }) => signers
)

export const selectSignersMeta = createSelector(
  (state: RootState) => {
    return state.signers
  },
  ({ meta }) => meta
)

export default signersSlice.reducer